import React from 'react';
import { Box } from '@mui/material';
import { DetailedSectionEvaluation } from '../../../redux/types';

type Props = {
  answers: DetailedSectionEvaluation['questions']['key']['answersBySamples'][0]['cumulatedAnswers'];
}

const AnswerDescriptionBox: React.FC<Props> = ({ answers }: Props) => (
  <Box
    sx={{
      minWidth: '15%',
      maxWidth: '15%',
      '& p': {
        textAlign: 'left',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
      },
    }}
  >
    {
          Object.keys(answers).map(
            (uuid) => (
              <div key={uuid}>
                <p
                  key={uuid}
                >
                  { answers[uuid].translatable.text }
                </p>
              </div>
            ),
          )
        }
  </Box>
);

export default AnswerDescriptionBox;
